export default __webpack_public_path__ + "static/media/classificacao.0b18635e.svg";